<div class="wrapper">
    <div class="header">
        <div>Label</div>
        <svg-icon
            (click)="close$.next()"
            [svgStyle]="{ 'width.px': 18, fill: '#6c757d', cursor: 'pointer' }"
            src="assets/images/icon-menu-close.svg"></svg-icon>
    </div>
    <div class="add-label-input">
        <input
            placeholder="Create label"
            ngModel
            #createLabelTitelInput="ngModel"
            type="text" />
        <span
            class="add"
            (click)="emitOpenEditDialog({ name: createLabelTitelInput.value })"
            >+</span
        >
    </div>
    <div class="all-label-list">
        <div
            class="loading-wrapper"
            *ngIf="isLoading$ | async">
            <mat-spinner [diameter]="50"></mat-spinner>
        </div>
        <div
            class="label-wrapper"
            *ngFor="let label of labels$ | async">
            <div
                class="label-item"
                (click)="assignLabelToOrder(label, params.type)"
                [style.backgroundColor]="label.colour">
                <span>{{ label.name }}</span>
                <ng-container *ngIf="assignedLabelsMap$ | async as assignedLabelsMap">
                    <svg-icon
                        *ngIf="assignedLabelsMap[label.id]"
                        [svgStyle]="{ 'width.px': 18, fill: '#fff' }"
                        src="assets/images/Check.svg"></svg-icon>
                </ng-container>
            </div>
            <svg-icon
                style="stroke: #263847"
                (click)="emitOpenEditDialog(label)"
                [svgStyle]="{ 'width.px': 20 }"
                src="assets/images/icon-edit.svg"></svg-icon>
        </div>
    </div>
</div>
